import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import PhoneClinicNavBar from '../../Components/PhoneClinicNavbar';
import expressIcon from '../../client/assets/images/about/express.png';
import happyIcon from '../../client/assets/images/about/happy.png';
import ecoIcon from '../../client/assets/images/about/eco.png';
import qualifiedIcon from '../../client/assets/images/about/qualified.png';
import qualityIcon from '../../client/assets/images/about/quality.png';
import warrantyIcon from '../../client/assets/images/about/warranty.png';
import logo from '../../assets/images/Logo.png';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import PhoneIcon from '@mui/icons-material/Phone';

const features = [
  { icon: expressIcon, title: 'Express Repairs', desc: 'Most repairs completed same day while you wait.' },
  { icon: happyIcon, title: 'Customer Satisfaction', desc: '100% satisfaction guaranteed on every repair.' },
  { icon: ecoIcon, title: 'Eco Friendly', desc: 'Committed to sustainable, responsible repair practices.' },
  { icon: qualifiedIcon, title: 'Qualified Technicians', desc: 'Fully certified, experienced repair specialists.' },
  { icon: qualityIcon, title: 'Quality Parts', desc: 'Genuine and premium-grade components only.' },
  { icon: warrantyIcon, title: 'Warranty Covered', desc: 'Up to lifetime warranty on select iPhone repairs.' },
];

const footerLinks = [
  { label: 'Home', to: '/' },
  { label: 'About Us', to: '/about-us' },
  { label: 'Services', to: '/services' },
  { label: 'Contact Us', to: '/contact-us' },
];

const repairTypes = [
  'Screen Replacement', 'Battery Replacement', 'Camera Repair',
  'Software Update', 'Water Damage', 'Network Unlocking',
];

function ClientLayout({ children }) {
  return (
    <div style={{ background: '#080808', minHeight: '100vh' }}>
      <PhoneClinicNavBar />

      {children}

      {/* Why Phone Clinic Section */}
      <section style={{
        background: '#0c0c0c',
        padding: '90px 5%',
        borderTop: '1px solid rgba(198,21,21,0.12)',
      }}>
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          style={{ textAlign: 'center', marginBottom: '64px' }}
        >
          <div style={{
            fontSize: '11px', letterSpacing: '4px', color: '#c61515',
            fontWeight: '800', marginBottom: '14px', textTransform: 'uppercase',
          }}>
            OUR PROMISE
          </div>
          <h2 style={{
            color: 'white', fontSize: 'clamp(28px, 4vw, 38px)',
            fontWeight: '800', margin: '0 0 18px',
          }}>
            Why Choose{' '}
            <span style={{
              background: 'linear-gradient(135deg, #dd4d4e, #780e0f)',
              WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text',
            }}>
              Phone Clinic?
            </span>
          </h2>
          <div style={{
            width: '50px', height: '3px',
            background: 'linear-gradient(90deg, #c61515, #780e0f)',
            margin: '0 auto',
          }} />
        </motion.div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(270px, 1fr))',
          gap: '20px', maxWidth: '1200px', margin: '0 auto',
        }}>
          {features.map((f, i) => (
            <motion.div
              key={f.title}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0, transition: { delay: i * 0.08, duration: 0.5 } }}
              viewport={{ once: true }}
              whileHover={{ y: -8, borderColor: 'rgba(198,21,21,0.45)' }}
              transition={{ duration: 0.3 }}
              style={{
                background: 'rgba(255,255,255,0.028)',
                border: '1px solid rgba(255,255,255,0.07)',
                borderRadius: '16px', padding: '32px 24px', textAlign: 'center',
              }}
            >
              <img
                src={f.icon} alt={f.title}
                style={{
                  width: '60px', height: '60px', objectFit: 'contain',
                  marginBottom: '16px',
                  filter: 'drop-shadow(0 0 14px rgba(198,21,21,0.35))',
                }}
              />
              <h4 style={{
                color: 'white', fontSize: '17px', fontWeight: '700', margin: '0 0 8px',
              }}>
                {f.title}
              </h4>
              <p style={{ color: '#777', fontSize: '13px', margin: 0, lineHeight: '1.65' }}>
                {f.desc}
              </p>
            </motion.div>
          ))}
        </div>
      </section>

      {/* Footer */}
      <footer style={{
        background: '#050505',
        borderTop: '1px solid rgba(198,21,21,0.16)',
        padding: '64px 5% 30px',
      }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(190px, 1fr))',
          gap: '44px', maxWidth: '1200px', margin: '0 auto',
          paddingBottom: '48px',
          borderBottom: '1px solid rgba(255,255,255,0.05)',
        }}>
          {/* Brand */}
          <div>
            <img src={logo} alt="Phone Clinic" style={{ height: '64px', marginBottom: '18px', display: 'block' }} />
            <p style={{ color: '#555', fontSize: '13px', lineHeight: '1.75', margin: '0 0 20px' }}>
              UK's trusted mobile phone repair and sales specialists. Quality repairs with warranty.
            </p>
            <div style={{ display: 'flex', gap: '8px' }}>
              {[MailOutlineIcon, PhoneIcon].map((Icon, i) => (
                <div key={i} style={{
                  width: '34px', height: '34px',
                  background: 'rgba(198,21,21,0.1)',
                  border: '1px solid rgba(198,21,21,0.25)',
                  borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center',
                }}>
                  <Icon style={{ color: '#c61515', fontSize: '16px' }} />
                </div>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h5 style={{
              color: 'white', fontSize: '11px', letterSpacing: '2.5px',
              fontWeight: '800', margin: '0 0 22px', textTransform: 'uppercase',
            }}>
              Quick Links
            </h5>
            {footerLinks.map(link => (
              <div key={link.label} style={{ marginBottom: '11px' }}>
                <Link to={link.to} style={{ textDecoration: 'none' }}>
                  <motion.span
                    whileHover={{ color: '#c61515', x: 4 }}
                    transition={{ duration: 0.2 }}
                    style={{ color: '#555', fontSize: '13px', display: 'inline-block' }}
                  >
                    → {link.label}
                  </motion.span>
                </Link>
              </div>
            ))}
          </div>

          {/* Repairs */}
          <div>
            <h5 style={{
              color: 'white', fontSize: '11px', letterSpacing: '2.5px',
              fontWeight: '800', margin: '0 0 22px', textTransform: 'uppercase',
            }}>
              Our Repairs
            </h5>
            {repairTypes.map(item => (
              <div key={item} style={{ marginBottom: '11px' }}>
                <span style={{ color: '#555', fontSize: '13px' }}>→ {item}</span>
              </div>
            ))}
          </div>

          {/* Contact */}
          <div>
            <h5 style={{
              color: 'white', fontSize: '11px', letterSpacing: '2.5px',
              fontWeight: '800', margin: '0 0 22px', textTransform: 'uppercase',
            }}>
              Head Office
            </h5>
            {[
              { Icon: LocationOnIcon, text: '6 Upper Market Square, Stoke On Trent, ST1 1NS' },
              { Icon: PhoneIcon, text: '01782 287557', href: 'tel:01782287557' },
              { Icon: MailOutlineIcon, text: 'info@phoneclinic4u.co.uk', href: 'mailto:info@phoneclinic4u.co.uk' },
            ].map(({ Icon, text, href }, i) => (
              <div key={i} style={{ display: 'flex', gap: '10px', marginBottom: '14px', alignItems: 'flex-start' }}>
                <Icon style={{ color: '#c61515', fontSize: '16px', marginTop: '2px', flexShrink: 0 }} />
                {href
                  ? <a href={href} style={{ color: '#555', fontSize: '13px', textDecoration: 'none' }}>{text}</a>
                  : <p style={{ color: '#555', fontSize: '13px', margin: 0, lineHeight: '1.5' }}>{text}</p>
                }
              </div>
            ))}
          </div>
        </div>

        <div style={{
          maxWidth: '1200px', margin: '28px auto 0',
          display: 'flex', justifyContent: 'space-between',
          alignItems: 'center', flexWrap: 'wrap', gap: '12px',
        }}>
          <p style={{ color: '#333', fontSize: '12px', margin: 0 }}>
            © 2024 Phone Clinic 4U. All rights reserved.
          </p>
          <a href="https://phoneclinic4u.co.uk" style={{ color: '#c61515', textDecoration: 'none', fontSize: '12px' }}>
            www.phoneclinic4u.co.uk
          </a>
        </div>
      </footer>
    </div>
  );
}

export default ClientLayout;
